import Container from "react-bootstrap/Container";

function Footer() {
  return (
    <footer>
      <Container fluid>
        <center className="p-3">
          © {new Date().getFullYear()} Honda Atlas Cars (Pakistan) Ltd.
        </center>
      </Container>
    </footer>
  );
}

export default Footer;
